<template>
  <header>
    <b-container>
      <b-navbar variant="faded" type="light">
        <b-navbar-brand href="#"><Logo /></b-navbar-brand>
        <b-navbar-brand href="#" class="ml-auto vconsol-logo"
          ><vconsol-logo
        /></b-navbar-brand>
        <!-- <b-link class="help-link ml-auto"><span>Help </span><Help /></b-link> -->
      </b-navbar>
    </b-container>
  </header>
</template>

<script>
import Logo from "./logo.vue";
import VconsolLogo from "./vconsol-logo.vue";
// import Help from "../components/svg/help.vue";
export default {
  name: "HeaderTemplate",
  components: {
    Logo,
    VconsolLogo
    // Help
  }
};
</script>
